import {Component, OnInit, ChangeDetectorRef} from '@angular/core';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {UsersService} from '../../../shared/services/users.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-verify',
    templateUrl: './verify.component.html',
    styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {
    constructor(
        private readonly usersService: UsersService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly router: Router,
    ) {
    }

    ngOnInit() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);

        this.usersService.verifyEmail(urlParams.get('code')).subscribe(() => {
            this.usersService.getUserProfile()
                .subscribe(async () => {
                    await this.router.navigate(['dashboard']);

                    this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
                });
        }, async () => {
            await this.router.navigate(['wizard']);
            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
        });
    }
}
